import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Instagram, Linkedin, Facebook } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (email) {
      setSent(true);
      setTimeout(() => setSent(false), 3000);
      setEmail('');
    }
  };

  return (
    <footer className="bg-[#1e1e1e] text-[#e9dfc0]">
      {/* Newsletter */}
      <section className="bg-[#3a3a3a] py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">Vuoi rimanere aggiornato sul mondo ecommerce?</h2>
          <p className="text-white/70 mb-8">Ricevi novità e aggiornamenti di questo mondo in continua evoluzione</p>
          <form onSubmit={submit} className="max-w-xl mx-auto relative">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="w-full bg-transparent border border-[#e9dfc0]/50 text-white placeholder:text-white/60 rounded-full py-4 px-6 pr-16 focus:outline-none focus:border-[#e9dfc0] transition-colors"
            />
            <button
              type="submit"
              aria-label="Subscribe"
              className="absolute right-2 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#e9dfc0] text-[#2b2b2b] flex items-center justify-center hover:bg-white transition-colors"
            >
              <ArrowRight className="w-5 h-5" />
            </button>
          </form>
          {sent && <p className="text-white mt-3 text-sm">Iscrizione ricevuta. Grazie!</p>}
        </div>
      </section>

      {/* Links */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <img src="/etech-logo.png" alt="ETech" className="h-11 w-11 object-contain mb-4" />
          <p className="text-sm text-[#e9dfc0]/70 leading-relaxed">
            Il tuo eCommerce, senza complicazioni. Consulenza, strategia e operativit&agrave;.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">SERVIZI</h4>
          <ul className="space-y-2 text-sm text-[#e9dfc0]/80">
            <li><Link to="/temporary-management" className="hover:text-white transition-colors">Temporary Management</Link></li>
            <li><Link to="/casi-studio" className="hover:text-white transition-colors">Casi Studio</Link></li>
            <li><Link to="/sviluppo-brand" className="hover:text-white transition-colors">Sviluppo Brand</Link></li>
            <li><Link to="/pocket-administration" className="hover:text-white transition-colors">Pocket Administration</Link></li>
            <li><Link to="/ecommerce-etico" className="hover:text-white transition-colors">Ecommerce Etico</Link></li>
            <li><Link to="/e-gas" className="hover:text-white transition-colors">E-Gas</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">AZIENDA</h4>
          <ul className="space-y-2 text-sm text-[#e9dfc0]/80">
            <li><Link to="/chi-siamo" className="hover:text-white transition-colors">Chi Siamo</Link></li>
            <li><Link to="/contatti" className="hover:text-white transition-colors">Contatti</Link></li>
            <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-white transition-colors">Cookie Policy</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">CONTATTI</h4>
          <ul className="space-y-2 text-sm text-[#e9dfc0]/80">
            <li>ETech S.r.l.</li>
            <li>Italia</li>
            <li><a href="mailto:info@etechpro.it" className="hover:text-white transition-colors">info@etechpro.it</a></li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-[#e9dfc0]/40 flex items-center justify-center hover:border-[#e9dfc0] hover:text-white transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-[#e9dfc0]/40 flex items-center justify-center hover:border-[#e9dfc0] hover:text-white transition-colors"><Linkedin className="w-4 h-4" /></a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-[#e9dfc0]/40 flex items-center justify-center hover:border-[#e9dfc0] hover:text-white transition-colors"><Facebook className="w-4 h-4" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#4a4a4a]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#e9dfc0]/60">
          <p>© {new Date().getFullYear()} ETech S.r.l. Tutti i diritti riservati.</p>
          <p>P.IVA IT00000000000</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
